import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './TweenStudioLogo.css';
export function Logo({ className }) {
    return (_jsxs("span", { className: `tween-studio-logo ${className ?? ''}`.trim(), children: [_jsx("span", { className: "tween-studio-logo-brand", children: "tween" }), _jsx("span", { className: "tween-studio-logo-studio", children: ".studio" })] }));
}
